import { createContext, useContext } from 'react';

export type IOnUserEditCallback = (id?: string) => void;

export const UserUpdateContext = createContext<IOnUserEditCallback>(() => void 0);

export const UserUpdateProvider = UserUpdateContext.Provider;

export const useOnUserUpdate = () => useContext(UserUpdateContext);
